import * as actions from './actionTypes'

export const cookiedEnabledAction = (flag) => ({
  type: actions.COOKIES_ENABLED,
  payload: {
    description: flag,
  },
})

export const screenLoadingAction = () => ({
  type: actions.SCREEN_LOADING,
})

export const fineNumberAction = (value) => ({
  type: actions.FINE_NUMBER,
  payload: {
    description: value,
  },
})

export const confirmFineNumberAction = (value) => ({
  type: actions.CONFIRM_FINE_NUMBER,
  payload: {
    description: value,
  },
})

export const fineOwingAction = (value) => ({
  type: actions.FINE_OWING,
  payload: {
    description: value,
  },
})

export const paymentAmountAction = (value) => ({
  type: actions.PAYMENT_AMOUNT,
  payload: {
    description: value,
  },
})

export const paymentAmountFullAction = (value) => ({
  type: actions.PAYMENT_AMOUNT_FULL,
  payload: {
    description: value,
  },
})

export const minPaymentAmountAction = (value) => ({
  type: actions.MIN_PAYMENT_AMOUNT,
  payload: {
    description: value,
  },
})

export const caseSotIdAction = (value) => ({
  type: actions.CASE_SOT_ID,
  payload: {
    description: value,
  },
})

export const receiptDetailAction = (value) => ({
  type: actions.RECEIPT_DETAIL,
  payload: {
    description: value,
  },
})

export const fineTypeAction = (value) => ({
  type: actions.FINE_TYPE,
  payload: {
    description: value,
  },
})

export const emailAddressAction = (value) => ({
  type: actions.EMAIL_ADDRESS,
  payload: {
    description: value,
  },
})

export const confirmEmailAddressAction = (value) => ({
  type: actions.CONFIRM_EMAIL_ADDRESS,
  payload: {
    description: value,
  },
})

export const editFineNumberAction = (fineNumber) => ({
  type: actions.EDIT_FINE_NUMBER,
  payload: {
    fineNumber: fineNumber,
  },
})

export const addFineAction = (data) => ({
  type: actions.ADD_FINE,
  payload: {
    fineNumber: data.fineNumber,
    fineOwing: data.fineOwing,
    paymentAmount: data.paymentAmount,
    paymentAmountFull: data.paymentAmountFull,
    minPaymentAmount: data.minPaymentAmount,
    caseSotId: data.caseSotId,
    receiptDetail: data.receiptDetail,
    fineType: data.fineType,
  },
})

export const editFineAction = (data) => ({
  type: actions.EDIT_FINE,
  payload: {
    fineNumber: data.fineNumber,
    fineOwing: data.fineOwing,
    paymentAmount: data.paymentAmount,
    paymentAmountFull: data.paymentAmountFull,
    minPaymentAmount: data.minPaymentAmount,
    caseSotId: data.caseSotId,
    receiptDetail: data.receiptDetail,
    fineType: data.fineType,
  },
})

export const deleteFineAction = (fineNumber) => ({
  type: actions.DELETE_FINE,
  payload: {
    fineNumber: fineNumber,
  },
})

export const clearFineAction = () => ({
  type: actions.CLEAR_FINE_INFO,
})

export const clearAllAction = () => ({
  type: actions.CLEAR_ALL,
})
